import { useRef, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import { logout } from "../../../../utils/auth";
import { useDispatch, useSelector } from "react-redux";

const GalaxyLayout = ({ children }) => {

  const userInfo = useSelector((state) => state.userStore);

  const [balance, setBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [expouser, setExpouser] = useState(0);

  useEffect(() => {
    setUsername(userInfo.data.uname);
    setBalance(parseInt(userInfo.data.bz_balance));
    setExpouser(
      parseInt(userInfo.data.opin_bal) - parseInt(userInfo.data.bz_balance)
    );
    //}
  }, [userInfo, setUsername, setExpouser, setBalance]);
  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };
  return (
    <div>
      <style>
        {` 
                body {
                    background: linear-gradient(180deg, #0D0D0D, #18122B);
                    color: #EAEAEA;
                    margin: 0;
                    padding: 0;
                    background-attachment: fixed;
                    touch-action: manipulation;
                }`}
      </style>
      <div>
        <nav className="navbar navbar-dark" style={{ padding: "1rem 1rem" }}>
          <div className="container main-container">
            <div className="d-flex gap-1 lobby-container">
              <Link
                to="/home"
                className="nav-link"
                style={{ textDecoration: "none" }}
              >
                <button className="lobby-btn">
                  <img
                    src="../assets/images/tpstudio/lobby-icon.svg"
                    alt="lobby-icon"
                  />
                  <p className="lobby-name">Home</p>
                </button>
              </Link>
            </div>
            <div className="d-flex align-items-center">
              <span
                className="wallet-balance me-3 site_family"
                style={{ fontSize: "16px", fontWeight: 400 }}
              >
                B:Rs.<span>{formatTruncate(balance)}</span>
              </span>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span
                className="wallet-exposure me-3 site_family"
                style={{ fontSize: "16px", fontWeight: 400 }}
              >
                {" "}
                | L:{" "}
                <span>
                  <span style={{ display: expouser != 0 ? "" : "none" }}>
                    -
                  </span>
                  {formatTruncate(expouser)}
                </span>
              </span>
            </div>
          </div>
        </nav>
      </div>
      <div id="RangBazMain">{children}</div>
    </div>
  );
};

export default GalaxyLayout;
